module.exports = __webpack_public_path__ + "img/icon_image_remove.4bd89e7a.svg";